export default {"src":"/_next/static/media/dishwasher.9592428e.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};